<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/plateau']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'plateau_common_name' | translate"></nz-statistic>
    </a>
</nz-card>